export function getIsTargetScoreRangeSingularValue(min: number | null | undefined, max: number | null | undefined) {
  return min === max || (min === null && max === null) || (min === undefined && max === undefined);
}
